import { SCALE, SIZE_COVER } from '../../constants';
import bgFrontCover from '@/assets/image/pdfexport/bg-front-cover.png';
import checkmarkShieldImg from '@/assets/image/pdfexport/checkmark-shield.png';
import { Box, Link, Typography, withStyles } from '@material-ui/core';
import { get } from 'lodash';
import React from 'react';

const width = SIZE_COVER.width * SCALE;
const height = SIZE_COVER.height * SCALE;

const FontCover = ({ consolidationData }) => {
  const companyName = get(consolidationData, 'projectInfo.companyName') || '';

  return (
    <CustomContainer>
      <Box pt={62.75 * SCALE}>
        <Title>
          Segmented Analysis
          <br />
          Report
        </Title>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={170 * SCALE}
          height={34 * SCALE}
          bgcolor="#3776AB"
          borderRadius={32}
          color="#FFFFFF"
          fontFamily="OpenSans"
          fontSize={12 * SCALE}
          fontWeight={600}
          gridGap={8}
        >
          <img
            alt="#"
            src={checkmarkShieldImg}
            style={{ width: 16 * SCALE, height: 16 * SCALE }}
          />
          Private & Confidential
        </Box>

        <InfoContainer>
          <InfoTitle>{companyName}</InfoTitle>
        </InfoContainer>
      </Box>

      <SocialContainer>
        <Box fontSize={10 * SCALE}>@minmedgroup</Box>
        <Box fontSize={10 * SCALE}>
          <CustomLink href="www.minmed.sg" target="_blank">
            <span className="label">www.minmed.sg</span>
          </CustomLink>
        </Box>
        <Box fontSize={10 * SCALE}>
          <CustomLink href="https://wa.me/6592300123" target="_blank">
            <span className="label">https://wa.me/6592300123</span>
          </CustomLink>
        </Box>
      </SocialContainer>
    </CustomContainer>
  );
};

const CustomContainer = withStyles({
  root: {
    padding: `0 ${40 * SCALE}px`,
    height,
    width,
    margin: '0 auto',
    backgroundImage: `url(${bgFrontCover})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
  },
})(Box);
const CustomLink = withStyles({
  root: {
    color: '#333',
  },
})(Link);

const SocialContainer = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'absolute',
    width: 480 * SCALE,
    bottom: 32 * SCALE,
    left: 100 * SCALE,
  },
})(Box);

const InfoTitle = withStyles({
  root: {
    fontFamily: 'OpenSans',
    fontWeight: 700,
    fontSize: 16 * SCALE,
    lineHeight: `${24 * SCALE}px`,
    letterSpacing: 0,
    marginBottom: 16 * SCALE,
    color: '#333333',
  },
})(Box);

const InfoContainer = withStyles({
  root: {
    backgroundColor: '#fff',
    borderRadius: 12 * SCALE,
    padding: 20 * SCALE,
    marginTop: 18 * SCALE,
    border: '1px solid #fafafa',
  },
})(Box);

const Title = withStyles({
  root: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 48 * SCALE,
    lineHeight: `${46 * SCALE}px`,
    letterSpacing: 0,
    marginBottom: 20 * SCALE,
    color: '#333333',
  },
})(Typography);

export default FontCover;
